import { gql } from "@apollo/client";

// Loads everything the Order Ahead overview needs for one event in a single
// round trip: every order-ahead menu (locations_order_ahead) and every
// order-ahead item, so menus can be grouped by vendor and their category
// item IDs resolved to item details on the client.
export const GET_ORDER_AHEAD_OVERVIEW = gql`
  query OrderAheadOverview(
    $locWhere: locations_order_ahead_bool_exp
    $itemWhere: items_order_ahead_bool_exp
  ) {
    locations_order_ahead(where: $locWhere, order_by: { name: asc }) {
      id
      name
      is_active
      zone
      location_type
      is_pickup
      pickup_note
      is_tips
      digital_surcharge_percentage
      url_guid
      category
      event_id
      vendor_id
      vendor {
        id
        name
      }
      event {
        id
        name
      }
      payment_processor_config {
        id
        payment_processor
      }
    }
    items_order_ahead(where: $itemWhere, order_by: { name: asc }) {
      id
      name
      price
      tax_percentage
      tax_type
      category
      is_active
      available_public_sale
      vendor_id
      vendor {
        id
        name
      }
    }
  }
`;

// The event's landing slugs. The order-ahead landing slug lives in the event's
// `configuration` JSONB under an `order_ahead_slug` key, kept separate from `slug`
// (used by the cashless landing).
export const GET_EVENT_LANDING_SLUGS = gql`
  query EventLandingSlugs($eventId: Int!) {
    events(where: { id: { _eq: $eventId } }) {
      id
      slug
      configuration
    }
  }
`;
